import clsx from "clsx";
import PropTypes from "prop-types";
import { Modal as SemanticModal } from "semantic-ui-react";
import { ModalActions } from "./ModalActions";
import { ModalContent } from "./ModalContent";
import { ModalDimmer } from "./ModalDimmer";
import { ModalHeader } from "./ModalHeader";

export const Modal = ({ className = "", ...props }) => {
  return (
    <SemanticModal
      {...props}
      dimmer={{ className: "ha-modal-dimmer" }}
      className={clsx("ha-modal", className)}
    />
  );
};

Modal.propTypes = {
  className: PropTypes.string,
};

Modal.Actions = ModalActions;
Modal.Content = ModalContent;
Modal.Description = SemanticModal.Description;
Modal.Dimmer = ModalDimmer;
Modal.Header = ModalHeader;
